import http from "./utils";
import { prefix, mockPrefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const getNewsStatsTimeline: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/news/stats_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getNewsChannel: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  return http({
    url: `${prefix}/news/channel`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

export const getNewsLanguage: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (payload, cancelTokenFunc = (c) => {}) => {
  return http({
    url: `${prefix}/news/language`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<any>;
};

export const getNewsCountry: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/news/country`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
